export const useGetPageContainerSyles = () => {
  return {
    pageContainer: {
      display: "flex",
      width: "100%",
      minHeight: "100vh",
      flexDirection: "column",
      fontFamily:
        "'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
  };
};
